export const VALID_DIVISIONS = ["D1", "D2", "D3", "D4", "D5"] as const;
export type Division = (typeof VALID_DIVISIONS)[number];

export function isValidDivision(value: string): value is Division {
  return VALID_DIVISIONS.includes(value as Division);
}
